import { Component, OnInit, Inject, ViewChild } from "@angular/core";
import { MdDialogRef, MD_DIALOG_DATA, DateAdapter } from "@angular/material";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from "@angular/forms";

import { ItemTypeManagerComponent } from "../item-type-manager/item-type-manager.component";

import { DashboardService } from "../../../services/dashboard.service";
import { SharedService } from "../../../services/shared.service";

import { BloccoModel } from "../../../models/dashboard/blocco.model";
import { SliderModel } from "../../../models/dashboard/slider.model";
import { SaveBloccoModel } from "../../../models/dashboard/saveBlocco.model";

import * as _ from "lodash";

@Component({
  selector: "app-item-slider-manager",
  templateUrl: "./item-slider-manager.component.html",
  styleUrls: ["./item-slider-manager.component.css"],
})
export class ItemSliderManagerComponent implements OnInit {
  blocco: BloccoModel;
  form: FormGroup;

  idBlocco: number;
  tipi: Array<string> = [];
  blocchi: Array<BloccoModel> = [];

  currentSlider: SliderModel;

  title = "Inserimento blocco in pagina";

  constructor(
    private formBuilder: FormBuilder,
    private dialogRef: MdDialogRef<ItemSliderManagerComponent>,
    private _dashboardService: DashboardService,
    private _sharedService: SharedService,
    @Inject(MD_DIALOG_DATA) data
  ) {}

  ngOnInit() {
    this.currentSlider = this._sharedService.getSlider();
    const filters = `tokenSlider=${this.currentSlider.token}&flagAssociato=false`;
    this._dashboardService.getAllBlocchi(filters).subscribe((data) => {
      this.blocchi = data;
    });
    this.createForm(this.formBuilder);
    this.order().disable();
  }

  closeDialogRef(itemsToReturn?: any) {
    this.dialogRef.close(itemsToReturn);
  }

  createForm(fb: FormBuilder) {
    this.form = fb.group({
      order: new FormControl(
        this.currentSlider.blocchiInfo.length,
        Validators.compose([
          Validators.required,
          Validators.min(0),
          Validators.max(this.currentSlider.blocchiInfo.length - 1),
        ])
      ),
      block: new FormControl("", Validators.required),
    });
  }

  saveAndUpdateSlider() {
    const bloccoToSlider = {
      idBlocco: this.block().value.id,
      idSlider: this.currentSlider.id,
      ordineBlocco: this.currentSlider.blocchiInfo.length,
      dataInizio: new Date().toISOString(),
    };

    this._dashboardService
      .addBloccoToSlider(bloccoToSlider)
      .subscribe((sliderRes) => {
        this.closeDialogRef({
          idBlocco: this.block().value.id,
          order: this.order().value,
        });
      });
  }

  edit() {
    this.closeDialogRef({
      editBlocco: true,
      blocco: this.block().value,
      idBlocco: this.block().value.id,
    });
  }

  block = () => this.form.get("block");
  order = () => this.form.get("order");
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/item-slider-manager/item-slider-manager.component.ts